import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { SharedModule } from 'app/shared/shared.module';
import { BaseKnowledgeCatalogComponent } from './base-knowledge-catalog.component';
import { BaseKnowledgeCatalogService } from './services/base-knowledge-catalog.service';

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './i18n/', '.json');
}

@NgModule({
  declarations: [
    BaseKnowledgeCatalogComponent
  ],
  imports: [
    TranslateModule.forChild({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    CommonModule,
    SharedModule
  ],
  exports: [
    BaseKnowledgeCatalogComponent
  ],
  providers: [
    BaseKnowledgeCatalogService
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class BaseKnowledgeCatalogModule { }
